import { render, staticRenderFns } from "./EcoRating.vue?vue&type=template&id=0f6d676e&"
import script from "./EcoRating.vue?vue&type=script&lang=js&"
export * from "./EcoRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f6d676e')) {
      api.createRecord('0f6d676e', component.options)
    } else {
      api.reload('0f6d676e', component.options)
    }
    module.hot.accept("./EcoRating.vue?vue&type=template&id=0f6d676e&", function () {
      api.rerender('0f6d676e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/components/EcoRating.vue"
export default component.exports